<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
import { NavigationIcon } from '@blpde/nx-icons';
import { NxButton } from '@blpde/nx-ui';

const route = useRoute();
const router = useRouter();
const { t } = useI18n();

const permission = computed(() =>
  typeof route.query.permission === 'string' ? route.query.permission : ''
);
</script>

<template>
  <section class="permission-denied" role="alert">
    <!-- eslint-disable-next-line @intlify/vue-i18n/no-raw-text -->
    <div class="permission-denied__status">403</div>
    <h1>{{ t('permissions.denied.title') }}</h1>
    <p>{{ t('permissions.denied.message') }}</p>
    <p v-if="permission" class="permission-denied__permission">
      {{ t('permissions.denied.missing', { permission }) }}
    </p>
    <NxButton height="s" variant="outline" @click="router.back()">
      <NavigationIcon filled class="nxt-icon-lg" />
      {{ t('permissions.denied.back') }}
    </NxButton>
  </section>
</template>

<style scoped>
.permission-denied {
  width: 100%;
  height: 100%;
  min-height: var(--nxt-area-size-2xl);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--nxt-space-sm);
  text-align: center;
  color: var(--nxt-fg);
}

.permission-denied__status {
  font-size: var(--nxt-font-size-xs);
  font-weight: var(--nxt-font-weight-bold);
  letter-spacing: 0;
  color: var(--nxt-danger-bg);
  background: var(--nxt-danger-subtle-bg);
  border: var(--nxt-hairline) solid var(--nxt-danger-border);
  border-radius: var(--nxt-radius-sm);
  padding: var(--nxt-space-2xs) var(--nxt-space-xs);
}

h1 {
  margin: 0;
  font-size: var(--nxt-font-size-2xl);
  line-height: var(--nxt-line-height-tight);
}

p {
  margin: 0;
  max-width: var(--nxt-panel-width-3xl);
  color: var(--nxt-fg-muted);
}

.permission-denied__permission {
  font-family: var(--nxt-font-mono);
  font-size: var(--nxt-font-size-sm);
  color: var(--nxt-fg-muted);
}
</style>
